export enum IconName {
    AccountingLedger = 'accounting_ledger',
    AccountingReport = 'accounting_report',
    ActionLog = 'action_log',
    ActivityReport = 'activity_report',
    Add = 'add',
    AddCustomer = 'add_customer',
    AI = 'AI',
    AlertCircle = 'alert_circle',
    Analytics = 'analytics',
    Archive = 'archive',
    Arrivals = 'arrivals',
    ArrowCounterClockwise1 = 'arrow_counter_clockwise_1',
    ArrowCounterClockwise2 = 'arrow_counter_clockwise_2',
    ArrowCounterClockwise3 = 'arrow_counter_clockwise_3',
    ArrowCounterClockwise4 = 'arrow_counter_clockwise_4',
    ArrowCounterClockwise5 = 'arrow_counter_clockwise_5',
    ArrowCounterClockwise6 = 'arrow_counter_clockwise_6',
    ArrowCounterClockwise7 = 'arrow_counter_clockwise_7',
    ArrowCounterClockwise8 = 'arrow_counter_clockwise_8',
    ArrowCounterClockwise9 = 'arrow_counter_clockwise_9',
    ArrowCounterClockwise9plus = 'arrow_counter_clockwise_9_plus',
    ArrowDown = 'arrow_down',
    ArrowJoined = 'arrow_joined',
    ArrowLeft = 'arrow_left',
    ArrowRight = 'arrow_right',
    ArrowUp = 'arrow_up',
    Assign = 'assign',
    AtMention = 'at_mention',
    Availability = 'availability',
    AvailableDates = 'available_dates',
    BabyCot = 'baby_cot',
    Backward = 'backward',
    Bathroom = 'bathroom',
    Bike = 'bike',
    BillsInvoices = 'bills_invoices',
    Birthday = 'birthday',
    Blacklist = 'blacklist',
    Bold = 'bold',
    Breadcrumb = 'breadcrumb',
    Briefcase = 'briefcase',
    Broom = 'broom',
    BuildingPlus = 'building_plus',
    BulbStars = 'bulb_stars',
    BulkEdit = 'bulk_edit',
    Bus = 'bus',
    Calendar = 'calendar',
    CalendarDay = 'calendar_day',
    CalendarMonth = 'calendar_month',
    CalendarStars = 'calendar_stars',
    CalendarWeek = 'calendar_week',
    Call = 'call',
    Camera = 'camera',
    CampingPitch = 'camping_pitch',
    CancelSquare = 'cancel_square',
    Caravan = 'caravan',
    CardCheck = 'card_check',
    CardKeys = 'card_keys',
    CardNfc = 'card_nfc',
    CaretFilledDown = 'caret_filled_down',
    CaretFilledUp = 'caret_filled_up',
    Cashier = 'cashier',
    Cashlist = 'cashlist',
    CashPayment = 'cash_payment',
    ChannelManager = 'channel_manager',
    Charge = 'charge',
    Chargeable = 'chargeable',
    Chargeback = 'chargeback',
    CheckboxEmpty = 'checkbox_empty',
    CheckboxTick = 'checkbox_tick',
    CheckCircle = 'done_circle',
    CheckedIn = 'checked_in',
    CheckedOut = 'checked_out',
    Checkin = 'checkin',
    Checkout = 'checkout',
    ChevronDown = 'chevron_down',
    ChevronLeft = 'chevron_left',
    ChevronRight = 'chevron_right',
    ChevronUp = 'chevron_up',
    ChildHead = 'child_head',
    City = 'city',
    ClearSelection = 'clear_selection',
    CollapseAll = 'collapse_all',
    Companies = 'companies',
    Complaint = 'complaint',
    Configuration = 'configuration',
    Connect = 'connect',
    Copy = 'copy',
    Countries = 'countries',
    CovidProtection = 'covid_protection',
    CreditCardFile = 'credit_card_file',
    Crib = 'crib',
    CrossClose = 'cross_close',
    Cultures = 'cultures',
    CurrencySwitch = 'currency_switch',
    CustomerProfiles = 'customer_profiles',
    CustomerSuccess = 'customer_success',
    CustomLink = 'custom_link',
    Dashboard = 'dashboard',
    Delete = 'delete',
    Departures = 'departures',
    Deployments = 'deployments',
    Desk = 'desk',
    DeviceCommand = 'device_command',
    Disability = 'disability',
    Disable = 'disable',
    DollarArrowDown = 'dollar_arrow_down',
    Done = 'done',
    DoorHanger = 'door_hanger',
    DoubleBed = 'double_bed',
    Download = 'download',
    Draggable = 'draggable',
    DrivingLicence = 'driving_licence',
    Edit = 'edit',
    Education = 'education',
    EmailQueue = 'email_queue',
    EmailQueues = 'email_queues',
    Employees = 'employees',
    ErrorCircle = 'error_circle',
    Execute = 'execute',
    ExecuteMerchant = 'execute_merchant',
    Expand = 'expand',
    ExpandAll = 'expand_all',
    Experiences = 'experiences',
    Exports = 'exports',
    ExportSchedule = 'export_schedule',
    ExternalLink = 'external_link',
    ExternalPayment = 'external_payment',
    ExtraBed = 'extrabed',
    Facebook = 'facebook',
    FaceHappy = 'face_happy',
    FaceId = 'face_id',
    FaceSad = 'face_sad',
    FastBackwardSimple = 'fast_backward_simple',
    FastForwardSimple = 'fast_forward_simple',
    Features = 'features',
    Female = 'female',
    FileCheck = 'file_check',
    Filter = 'filter',
    Finance = 'finance',
    FiscalReport = 'fiscal_report',
    FloppyDisc = 'floppy_disc',
    FolderClosed = 'folder_closed',
    FolderOpened = 'folder_opened',
    Food = 'food',
    ForumOutline = 'forum_outline',
    Forward = 'forward',
    Free = 'free',
    FriendFamily = 'friend_family',
    Ftp = 'ftp',
    GatewayPayments = 'gateway_payments',
    Gift = 'gift',
    GuestInHouse = 'guest_in_house',
    Guides = 'guides',
    Help = 'help',
    HelpCenter = 'help_center',
    Hide = 'hide',
    Home = 'home',
    HomeEmpty = 'home_empty',
    Hourglass = 'hourglass',
    HouseUse = 'house_use',
    IdCard = 'id_card',
    Important = 'important',
    Imports = 'imports',
    ImportCustomers = 'import_customers',
    Improvement = 'improvement',
    Info = 'info',
    Installations = 'installations',
    IntegrationPartners = 'integration_partners',
    Integrations = 'integrations',
    InventoryUpdates = 'inventory_updates',
    Italic = 'italic',
    Items = 'items',
    Jobs = 'jobs',
    Key = 'key',
    Languages = 'languages',
    LanguageSwitch = 'language_switch',
    LegalEnvironments = 'legal_environments',
    LightningBolt = 'lightning_bolt',
    Linkedin = 'linkedin',
    ListOrdered = 'list_ordered',
    Location = 'location',
    Lock = 'lock',
    Logout = 'logout',
    Loyalty = 'loyalty',
    Luggage = 'luggage',
    Magic = 'magic',
    Mails = 'mails',
    MakeDefault = 'make_default',
    Male = 'male',
    ManagerReport = 'manager_report',
    MarkAsRead = 'mark_as_read',
    Marketplace = 'marketplace',
    Media = 'media',
    Megaphone = 'megaphone',
    Menu = 'menu',
    MenuArrowLeft = 'menu_arrow_left',
    MenuArrowRight = 'menu_arrow_right',
    Merchant = 'merchant',
    Message = 'message',
    MessagesPlural = 'messages_plural',
    MewsLogo = 'mews_logo',
    Microphone = 'microphone',
    Military = 'military',
    Minus = 'minus',
    MinusSimple = 'minus_simple',
    More = 'more',
    Move = 'move',
    MovePayment = 'move_payment',
    MovePaymentHorizontal = 'move_payment_horizontal',
    NonbreakingSpace = 'nonbreaking_space',
    Notes = 'notes',
    Notifications = 'notifications',
    Occupancy = 'occupancy',
    Operations = 'operations',
    OutOfOrder = 'out_of_order',
    Paperclip = 'paperclip',
    Passport = 'passport',
    PastShifts = 'past_shifts',
    Paymaster = 'paymaster',
    PaymentAttempts = 'payment_attempts',
    PaymentCard = 'payment_card',
    PaymentReport = 'payment_report',
    PaymentRequest = 'payment_request',
    Payments = 'payments',
    Phone = 'phone',
    PhotoExpand = 'photo_expand',
    Pin = 'pin',
    Places = 'places',
    PlacesPin = 'places_pin',
    Plane = 'plane',
    PlatformMigrations = 'platform_migrations',
    PlusSimple = 'plus_simple',
    PostingJournal = 'posting_journal',
    PowerBi = 'power_bi',
    Preauthorization = 'preauthorization',
    Pricing = 'pricing',
    Print = 'print',
    PrintPdf = 'print_pdf',
    Problematic = 'problematic',
    Product = 'product',
    ProductReport = 'product_report',
    Profile = 'profile',
    Profiles = 'profiles',
    Property = 'property',
    Queues = 'queues',
    Quote = 'quote',
    RadioEmpty = 'radio_empty',
    RadioSelected = 'radio_selected',
    RateManagement = 'rate_management',
    Rebate = 'rebate',
    Refresh = 'refresh',
    Refund = 'refund',
    ReportBug = 'report_bug',
    ReservationGroup = 'reservation_group',
    ReservationOverview = 'reservation_overview',
    ReservationProperties = 'reservation_properties',
    ReservationPreview = 'reservation_preview',
    ReservationReport = 'reservation_report',
    Reservations = 'reservations',
    Reset = 'reset',
    Restore = 'restore',
    Restriction = 'restriction',
    Return = 'return',
    Room = 'room',
    ScanId = 'scan_id',
    Scanner = 'scanner',
    ScanQr = 'scan_qr',
    Schedules = 'schedules',
    Search = 'search',
    Security = 'security',
    SendMessage = 'send_message',
    Services = 'services',
    Settings = 'settings',
    SettingsUser = 'settings_user',
    Share = 'share',
    SharedData = 'shared_data',
    Show = 'show',
    Shrink = 'shrink',
    SpaceStatus = 'space_status',
    SpecialCharacter = 'special_character',
    SpentNights = 'spent_nights',
    Spinner = 'spinner',
    Split = 'split',
    Staff = 'staff',
    Stars = 'stars',
    StarFilled = 'star_filled',
    Statistics = 'statistics',
    Stayovers = 'stayovers',
    Strikethrough = 'strikethrough',
    Subscription = 'subscription',
    Summary = 'summary',
    SummaryOrder = 'summary_order',
    SwitchVideo = 'switch_video',
    Targets = 'targets',
    Tasks = 'tasks',
    TaxEnvironment = 'tax_environment',
    TeamArea = 'team_area',
    Tent = 'tent',
    Terminal = 'terminal',
    TerminalPayment = 'terminal_payment',
    TextAlignCenter = 'text_align_center',
    TextAlignJustify = 'text_align_justify',
    TextAlignLeft = 'text_align_left',
    TextAlignRight = 'text_align_right',
    TextLineHeight = 'text_line_height',
    ThumbsDown = 'thumbs_down',
    ThumbsUp = 'thumbs_up',
    Time = 'time',
    Timeline = 'timeline',
    TimelineCompact = 'timeline_compact',
    TimelineDense = 'timeline_dense',
    TimelineSpacious = 'timeline_spacious',
    ToggleLeft = 'toggle_left',
    ToggleRight = 'toggle_right',
    TopManagement = 'top_management',
    Train = 'train',
    TravelAgency = 'travel_agency',
    TravelClub = 'travel_club',
    TravelVisa = 'travel_visa',
    Tripadvisor = 'tripadvisor',
    Twitter = 'twitter',
    Underline = 'underline',
    Unlock = 'unlock',
    Upgraded = 'upgraded',
    Upload = 'upload',
    UserCardStack = 'user_card_stack',
    UserClock = 'user_clock',
    UserRefresh = 'user_refresh',
    VeryImportant = 'very_important',
    ViewOff = 'view_off',
    ViewReport = 'view_report',
    Website = 'website',
    Wellness = 'wellness',
    Window = 'window',
}
